export const emptyObject = {};